/*
 * This Config object is used throughout the application to
 * personalise your code and preferences for how you would
 * like things to work.
 *
 * For example, use the Config object to configure your menu links
 * without editing HTML, or change the page size on /blog without
 * touching any of the functional code.
 *
 */

const SITE_URL = "https://www.physicianleaders.org";

export const Config = {
	site: {
		owner: "American Association for Physician Leadership",
		title: "American Association for Physician Leadership",
		domain: "www.physicianleaders.org",
		email: "customerservice@physicianleaders.org",
		feedDescription: "RSS Feed for www.physicianleaders.org",
	},
	pageMeta: {
		openGraph: {
			twitterUser: "Physicianslead",
		},
		home: {
			url: SITE_URL,
			slug: "/",
		},
		blogIndex: {
			url: `${SITE_URL}/articles`,
			slug: "/articles",
		},
		blogIndexPage: {
			slug: "/articles/page/[page]",
		},
		post: {
			slug: "/articles/[slug]",
		},
		buildRss: {
			url: `${SITE_URL}/buildrss`,
			slug: "/buildrss",
		},
		notFound: {
			url: SITE_URL,
			slug: "/404",
		},
	},
	pagination: {
		// testing this - everything else is a placeholder
		pageSize: 12,
		recentPostsSize: 3,
		pressReleasesList: 10,
	},
	menuLinks: [
		{
			displayName: "Home",
			path: "/",
		},
		{
			displayName: "Articles",
			path: "/articles",
		},
	],
	//TODO: get some structure to the products, types, variants, and deliveries
	product: {
		types: {
			assessment: {},
			Webinar: {},
			"resource kit": {},
			book: {
				variants: ["audio book", "ebook", "hard cover", "soft cover"],
			},
			whitepaper: {},
			article: {},
			course: {
				variants: ["in-person", "hybrid online", "self-study"],
			},
			membership: {},
			journal: {
				PLJ: {
					journalId: "7zekz3wea4jdelky36wEKM",
				},
				HALMJ: {
					journalId: "4Y6CB81isD6RpH4rbYey3D",
				},
				JMPM: {
					journalId: "5S1WM3ie14VRYxzHqJ7GF",
				},
				FAST_PRACTICE: {
					journalId: "1uUgnIDOIm9TRaU4oRH82i",
				},
			},
			"other subscription": {},
		},
	},
};
